import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ind-card" },
    [
      _c("div", { staticClass: "ind-card-header" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
        _vm.subtitle
          ? _c("span", { staticClass: "ind-subtitle" }, [
              _vm._v(_vm._s(_vm.subtitle)),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "ind-col-labels" }, [
        _c("span", [_vm._v(_vm._s(_vm.negocioLabel))]),
        _c("span", { staticClass: "text-right" }, [_vm._v("S/mm")]),
        _c("span", { staticClass: "text-right" }, [_vm._v("VAR. AA")]),
        _c("span", { staticClass: "text-right" }, [_vm._v("VAR. PPTO")]),
      ]),
      _vm._l(_vm.items, function (item) {
        return _c(
          "div",
          { key: item.row_number, staticClass: "ind-row" },
          [
            _c(
              VTooltip,
              {
                attrs: { bottom: "", disabled: !item.fecha },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "span",
                            _vm._g(
                              _vm._b(
                                { staticClass: "brand-name" },
                                "span",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm._v(
                                _vm._s(item.row_number) +
                                  ". " +
                                  _vm._s(item.negocio)
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [_c("span", [_vm._v("Dato a: " + _vm._s(_vm.fechaLabel(item)))])]
            ),
            _c("span", { staticClass: "val-cell" }, [
              _vm._v(_vm._s(_vm.fmtMM(item.valor))),
            ]),
            _c("span", { staticClass: "val-cell" }, [
              _c("span", { class: _vm.badgeClass(item.var_anio_anterior) }, [
                _vm._v(_vm._s(_vm.fmtPct(item.var_anio_anterior))),
              ]),
            ]),
            _c("span", { staticClass: "val-cell" }, [
              _c("span", { class: _vm.badgeClass(item.var_presupuesto) }, [
                _vm._v(_vm._s(_vm.fmtPct(item.var_presupuesto))),
              ]),
            ]),
          ],
          1
        )
      }),
      _vm.totalItem
        ? _c("div", { staticClass: "ind-row total-row" }, [
            _c("span", { staticClass: "brand-name" }, [_vm._v("TOTAL")]),
            _c("span", { staticClass: "val-cell" }, [
              _vm._v(_vm._s(_vm.fmtMM(_vm.totalItem.valor))),
            ]),
            _c("span", { staticClass: "val-cell" }, [
              _c(
                "span",
                { class: _vm.badgeClass(_vm.totalItem.var_anio_anterior) },
                [_vm._v(_vm._s(_vm.fmtPct(_vm.totalItem.var_anio_anterior)))]
              ),
            ]),
            _c("span", { staticClass: "val-cell" }, [
              _c(
                "span",
                { class: _vm.badgeClass(_vm.totalItem.var_presupuesto) },
                [_vm._v(_vm._s(_vm.fmtPct(_vm.totalItem.var_presupuesto)))]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }